import { render, staticRenderFns } from "./MainCustomerAgreement.vue?vue&type=template&id=2ca16d96&scoped=true"
import script from "./MainCustomerAgreement.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainCustomerAgreement.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MainCustomerAgreement.vue?vue&type=style&index=0&id=2ca16d96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca16d96",
  null
  
)

export default component.exports